import script from "./CountryCodeSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryCodeSelect.vue?vue&type=script&setup=true&lang=ts"

import "./CountryCodeSelect.vue?vue&type=style&index=0&id=fae9b64e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fae9b64e"]])

export default __exports__